import React, { useMemo } from 'react';
import useRevenueByGeographics from '../../hooks/useRevenueByGeographics';
import Table from '../Table/Table';
import style from './RevenueSources.module.css';
import { formatCurrency } from '../../helpers/format';

const RevenueSourcesGeographics = ({ stock }) => {
  const { revenueByGeographics } = useRevenueByGeographics(stock.id);

  const totalRevenue = useMemo(() => {
    if (!revenueByGeographics) return 0;
    return revenueByGeographics.reduce((sum, item) => {
      const revenue = parseFloat(item.revenue);
      return sum + (revenue || 0)
    }, 0);
  }, [revenueByGeographics]);

  if (!revenueByGeographics || totalRevenue === 0) {
    return (
      <div>
        <p className={style.noData}>No data</p>
      </div>
    );
  }

  return (
    <Table>
      <tbody>
        {revenueByGeographics.map((item) => {
          const revenue = parseFloat(item.revenue) || 0;
          const percentage = (revenue && totalRevenue !== 0) ? ((revenue / totalRevenue) * 100).toFixed(2) : 0;
          return (
            <tr key={item.geopraphics}>
              <th>{item.geopraphics}</th>
              <td className={style.points}>
                ${formatCurrency(revenue, { compact: true })}
                {' '}
                <span className={style.percentage}>
                  ({percentage}%)
                </span>
              </td>
            </tr>
          );
        })}
      </tbody>
    </Table>
  );
};

export default RevenueSourcesGeographics;
